/**
 * Spinner themeable props.
 */
import { stringLiteralArray } from "../utils"

export default {
  appearances: stringLiteralArray(["default"]),
  subcomponents: stringLiteralArray(["wrapper", "box", "line"])
}
